const globalRoutes = [
    {path: '/404', component: () => import('@/views/common/404'), name: '404', meta: {title: '404未找到'}},
    {
        path: '/login', component: () => import('@/views/common/login'), name: 'login', meta: {title: '登录'},
        beforeEnter(to, from, next) {
            let token = sessionStorage.getItem('token')
            if (!token || !/\S/.test(token)) {
                next()
            }else{
                next({name: 'home'})
            }
        }
    },
    {
        path: '/login212', component: () => import('@/views/common/login212'), name: 'login212', meta: {title: '登录二一二越野车有限公司'},
        beforeEnter(to, from, next) {
            let token = sessionStorage.getItem('token')
            if (!token || !/\S/.test(token)) {
                next()
            }else{
                next({name: 'home'})
            }
        }
    },
    {
        path: '/loginBeijing', component: () => import('@/views/common/loginBeijing'), name: 'loginBeijing', meta: {title: '登录北京汽车制造厂有限公司'},
        beforeEnter(to, from, next) {
            let token = sessionStorage.getItem('token')
            if (!token || !/\S/.test(token)) {
                next()
            }else{
                next({name: 'home'})
            }
        }
    },
    {
        path: '/loginHuanghua', component: () => import('@/views/common/loginHuanghua'), name: 'loginHuanghua', meta: {title: '登录魏桥智行（黄骅）专用车有限公司'},
        beforeEnter(to, from, next) {
            let token = sessionStorage.getItem('token')
            if (!token || !/\S/.test(token)) {
                next()
            }else{
                next({name: 'home'})
            }
        }
    },
    {
        path: '/loginHuanghua', component: () => import('@/views/common/loginHuanghua'), name: 'loginHuanghua', meta: {title: '登录魏桥智行（黄骅）专用车有限公司'},
        beforeEnter(to, from, next) {
            let token = sessionStorage.getItem('token')
            if (!token || !/\S/.test(token)) {
                next()
            }else{
                next({name: 'home'})
            }
        }
    },
    {
        path: '/loginLeichi', component: () => import('@/views/common/loginLeichi'), name: 'loginLeichi', meta: {title: '登录山东雷驰新能源汽车有限公司'},
        beforeEnter(to, from, next) {
            let token = sessionStorage.getItem('token')
            if (!token || !/\S/.test(token)) {
                next()
            }else{
                next({name: 'home'})
            }
        }
    },
    {
        path: '/loginLingtu', component: () => import('@/views/common/loginLingtu'), name: 'loginLingtu', meta: {title: '登录领途汽车有限公司'},
        beforeEnter(to, from, next) {
            let token = sessionStorage.getItem('token')
            if (!token || !/\S/.test(token)) {
                next()
            }else{
                next({name: 'home'})
            }
        }
    },
]

export default globalRoutes